<template>
  <div class="timer-clock">
    <div class="progress-container">
      <div
        class="progress-bar"
        :style="{ width: progressWidth }"
      />
    </div>
    <centre-spinner :loading="loading" />
  </div>
</template>

<script>
import spinner from 'src/views/components/SpinnerCentre';
export default {
  name: 'Timer',
  components: {
    'centre-spinner': spinner,
  },
  data () {
    return {
      loading: false,
      timerInterval: null,
      totalSeconds: 120,
      initialSeconds: 120,
    };
  },
  computed: {
    progressWidth () {
      const percentage = (this.totalSeconds / this.initialSeconds) * 100;
      return `${percentage}%`;
    },
  },
  mounted () {
    this.loadTimer();
    this.startTimer();
  },
  beforeDestroy () {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  },
  methods: {
    loadTimer () {
      const savedTime = localStorage.getItem('timerTime');
      if (savedTime) {
        this.totalSeconds = parseInt(savedTime, 10);
      }
    },
    startTimer () {
      this.timerInterval = setInterval(() => {
        if (this.totalSeconds <= 0) {
          clearInterval(this.timerInterval);
          localStorage.removeItem('timerTime');
          this.redirect();
          return;
        }

        this.totalSeconds--;
        localStorage.setItem('timerTime', this.totalSeconds);
      }, 1000);
    },
    redirect () {
      this.loading = true;
      localStorage.removeItem('timerTime');
      setTimeout(() => {
        this.$router.push({ name: 'DeviceCheckInCheckOut' });
      }, 1000);
    },
  },
};
</script>

<style scoped>
.timer-clock {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  display: flex;
  justify-content: center;
}

.progress-container {
  width: 100%;
  height: 8px;
  background-color: #ddd;
  position: relative;
}

.progress-bar {
  height: 100%;
  background-color: #ff7954;
  transition: width 1s linear;
}
</style>
